export const CREATE_VENDOR = 'createVendor';
export const FETCH_VENDOR_BY_ID = 'fetchVendorById';
export const FETCH_ORGANIZATION_VENDORS = 'fetchOrganizationVendors';
export const UPDATE_VENDOR_BY_ID = 'updateVendorById';
export const DELETE_VENDOR_BY_ID = 'deleteVendorById';
